const TRANSLATIONS = {
  en: {
    lobby_title: "Project Pigeon",
    lobby_subtitle: "Logistics Command Center",
    select_hub: "Select Hub",
    select_role: "Select Your Role",
    planner: "Planner",
    machinist: "Machinist",
    driver: "Driver",
    viewer: "Viewer",
    language_gate: "Select Language",
    enter_dashboard: "Enter Dashboard",
    back: "Back",
    exit: "Exit",
    // Planner
    planner_dashboard: "Planner Dashboard",
    fleet_intelligence: "Fleet Intelligence",
    all_regions: "All Regions",
    search_placeholder: "Search sites...",
    sites: "Sites",
    machines: "Machines",
    drivers_title: "Drivers",
    active: "Active",
    offline: "Offline",
    efficiency: "Efficiency",
    stops: "Stops",
    refuelings: "Refuelings",
    fleet_volume: "Fleet Volume",
    active_drivers: "Active",
    daily_progress: "Daily Progress",
    analyze: "Analyze",
    approve: "Approve",
    data_synced: "Data Synchronized",
    ping_sent: "Message Sent",
    high_five_sent: "High-Five Sent!",
    send_message: "Send Message",
    direct_communication: "Direct Communication",
    send_message_placeholder: "Type a message...",
    no_stops_yet: "No stops yet",
    recent_communication: "Recent Communication",
    recent_alerts: "Recent Alerts",
    live_feed: "Live Feed",
    new_requests: "New Requests",
    in_progress: "In Progress",
    completed: "Completed",
    fun_request: "Fun Request",
    fun_placeholder: "French fries with mayonnaise?",
    // Driver
    driver_dashboard: "Driver Dashboard",
    start_day: "Start Day",
    stop_day: "Stop Day",
    day_status: "Day Status",
    quick_actions: "Quick Actions",
    pause: "Break",
    breakdown: "Breakdown",
    my_planning: "My Planning",
    no_planning: "No planning yet",
    checklist: "Pre-Departure Checklist",
    mirrors: "Mirrors & Lights",
    tires: "Tires & Pressure",
    fuel_check: "Fuel Level Check",
    documents: "Documents & License",
    safety_gear: "Safety Gear",
    confirm_delivery: "Confirm Delivery",
    diesel_liters: "Diesel (L)",
    adblue_liters: "AdBlue (L)",
    deliver: "Deliver",
    messages: "Messages",
    info_hub: "Info Hub",
    high_five_wall: "High-Five Wall",
    my_rating: "My Rating",
    give_planner: "Give Planner",
    // Machinist
    machinist_dashboard: "Machinist Dashboard",
    select_site: "Select Site",
    current_site: "Current Site",
    machine_pool: "Machine Pool",
    fuel_request: "Fuel Request",
    tank_level: "Tank Level",
    adblue_needed: "AdBlue Needed",
    action_center: "Action Center",
    request_type: "Request Type",
    in_use: "In Use",
    defect: "Defect",
    maintenance: "Maintenance",
    transport_needed: "Transport",
    target_destination: "Target Destination",
    details_reason: "Details / Reason",
    send_to_planner: "Send to Planner",
    add_rental: "Add Rental Machine",
    machine_type: "Machine Type",
    fleet_id: "Fleet ID / Label",
    confirm_import: "Register Machine",
    echo_tracker: "Request Tracker",
    waiting: "Waiting",
    // General
    loading: "Loading...",
    error: "Error",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    confirm: "Confirm",
    no_data: "No data",
    refresh: "Refresh",
    calendar: "Calendar",
    feedback: "Feedback",
    feedback_placeholder: "Share your feedback about this site...",
    submit_feedback: "Submit Feedback",
    switch_driver: "Switch Driver",
    reschedule: "Reschedule",
  },
  nl: {
    lobby_title: "Project Pigeon",
    lobby_subtitle: "Logistiek Commandocentrum",
    select_hub: "Selecteer Hub",
    select_role: "Selecteer Je Rol",
    planner: "Planner",
    machinist: "Machinist",
    driver: "Chauffeur",
    viewer: "Kijker",
    language_gate: "Selecteer Taal",
    enter_dashboard: "Naar Dashboard",
    back: "Terug",
    exit: "Sluiten",
    planner_dashboard: "Planner Dashboard",
    fleet_intelligence: "Vloot Intelligentie",
    all_regions: "Alle Regio's",
    search_placeholder: "Zoek werven...",
    sites: "Werven",
    machines: "Machines",
    drivers_title: "Chauffeurs",
    active: "Actief",
    offline: "Offline",
    efficiency: "Efficiëntie",
    stops: "Stops",
    refuelings: "Tankbeurten",
    fleet_volume: "Vloot Volume",
    active_drivers: "Actief",
    daily_progress: "Dagvoortgang",
    analyze: "Analyse",
    approve: "Goedkeuren",
    data_synced: "Data Gesynchroniseerd",
    ping_sent: "Bericht Verzonden",
    high_five_sent: "High-Five Verzonden!",
    send_message: "Stuur Bericht",
    direct_communication: "Directe Communicatie",
    send_message_placeholder: "Typ een bericht...",
    no_stops_yet: "Nog geen stops",
    recent_communication: "Recente Communicatie",
    recent_alerts: "Recente Meldingen",
    live_feed: "Live Feed",
    new_requests: "Nieuwe Aanvragen",
    in_progress: "In Behandeling",
    completed: "Afgerond",
    fun_request: "Fun Request",
    fun_placeholder: "Frietjes met mayonaise?",
    driver_dashboard: "Chauffeur Dashboard",
    start_day: "Start Dag",
    stop_day: "Stop Dag",
    day_status: "Dagstatus",
    quick_actions: "Snelle Acties",
    pause: "Pauze",
    breakdown: "Panne",
    my_planning: "Mijn Planning",
    no_planning: "Nog geen planning",
    checklist: "Vertrekchecklist",
    mirrors: "Spiegels & Lichten",
    tires: "Banden & Druk",
    fuel_check: "Brandstofniveau",
    documents: "Documenten & Rijbewijs",
    safety_gear: "Veiligheidsuitrusting",
    confirm_delivery: "Bevestig Levering",
    diesel_liters: "Diesel (L)",
    adblue_liters: "AdBlue (L)",
    deliver: "Leveren",
    messages: "Berichten",
    info_hub: "Info Hub",
    high_five_wall: "High-Five Muur",
    my_rating: "Mijn Score",
    give_planner: "Geef Planner",
    machinist_dashboard: "Machinist Dashboard",
    select_site: "Selecteer Werf",
    current_site: "Huidige Werf",
    machine_pool: "Machinepark",
    fuel_request: "Tankverzoek",
    tank_level: "Tankniveau",
    adblue_needed: "AdBlue Nodig",
    action_center: "Actie Centrum",
    request_type: "Type Verzoek",
    in_use: "In Gebruik",
    defect: "Defect",
    maintenance: "Onderhoud",
    transport_needed: "Transport",
    target_destination: "Doellocatie",
    details_reason: "Details / Reden",
    send_to_planner: "Stuur naar Planner",
    add_rental: "Huurmachine Toevoegen",
    machine_type: "Machinetype",
    fleet_id: "Vloot ID / Label",
    confirm_import: "Machine Registreren",
    echo_tracker: "Verzoek Tracker",
    waiting: "Wachtend",
    loading: "Laden...",
    error: "Fout",
    save: "Opslaan",
    cancel: "Annuleren",
    delete: "Verwijderen",
    confirm: "Bevestigen",
    no_data: "Geen data",
    refresh: "Vernieuwen",
    calendar: "Kalender",
    feedback: "Feedback",
    feedback_placeholder: "Deel je feedback over deze werf...",
    submit_feedback: "Verstuur Feedback",
    switch_driver: "Wissel Chauffeur",
    reschedule: "Herplannen",
  },
  fr: {
    lobby_title: "Project Pigeon",
    lobby_subtitle: "Centre de Commandement Logistique",
    select_hub: "Sélectionner Hub",
    select_role: "Sélectionnez Votre Rôle",
    planner: "Planificateur",
    machinist: "Machiniste",
    driver: "Chauffeur",
    viewer: "Observateur",
    language_gate: "Sélectionnez la Langue",
    enter_dashboard: "Entrer dans le Tableau de Bord",
    back: "Retour",
    exit: "Quitter",
    planner_dashboard: "Tableau de Bord Planificateur",
    fleet_intelligence: "Intelligence Flotte",
    all_regions: "Toutes les Régions",
    search_placeholder: "Rechercher des sites...",
    sites: "Sites",
    machines: "Machines",
    drivers_title: "Chauffeurs",
    active: "Actif",
    offline: "Hors Ligne",
    efficiency: "Efficacité",
    stops: "Arrêts",
    refuelings: "Ravitaillements",
    fleet_volume: "Volume de Flotte",
    active_drivers: "Actif",
    daily_progress: "Progrès Quotidien",
    analyze: "Analyser",
    approve: "Approuver",
    data_synced: "Données Synchronisées",
    ping_sent: "Message Envoyé",
    high_five_sent: "High-Five Envoyé!",
    send_message: "Envoyer Message",
    direct_communication: "Communication Directe",
    send_message_placeholder: "Tapez un message...",
    no_stops_yet: "Pas encore d'arrêts",
    recent_communication: "Communication Récente",
    recent_alerts: "Alertes Récentes",
    live_feed: "Flux en Direct",
    new_requests: "Nouvelles Demandes",
    in_progress: "En Cours",
    completed: "Terminé",
    fun_request: "Demande Fun",
    fun_placeholder: "Frites avec mayonnaise?",
    driver_dashboard: "Tableau de Bord Chauffeur",
    start_day: "Commencer la Journée",
    stop_day: "Terminer la Journée",
    day_status: "Statut du Jour",
    quick_actions: "Actions Rapides",
    pause: "Pause",
    breakdown: "Panne",
    my_planning: "Mon Planning",
    no_planning: "Pas encore de planning",
    checklist: "Checklist Pré-Départ",
    mirrors: "Rétroviseurs & Feux",
    tires: "Pneus & Pression",
    fuel_check: "Niveau de Carburant",
    documents: "Documents & Permis",
    safety_gear: "Équipement de Sécurité",
    confirm_delivery: "Confirmer Livraison",
    diesel_liters: "Diesel (L)",
    adblue_liters: "AdBlue (L)",
    deliver: "Livrer",
    messages: "Messages",
    info_hub: "Centre d'Info",
    high_five_wall: "Mur des High-Fives",
    my_rating: "Ma Note",
    give_planner: "Donner au Planificateur",
    machinist_dashboard: "Tableau de Bord Machiniste",
    select_site: "Sélectionner le Site",
    current_site: "Site Actuel",
    machine_pool: "Parc Machines",
    fuel_request: "Demande de Carburant",
    tank_level: "Niveau du Réservoir",
    adblue_needed: "AdBlue Nécessaire",
    action_center: "Centre d'Action",
    request_type: "Type de Demande",
    in_use: "En Usage",
    defect: "Défaut",
    maintenance: "Entretien",
    transport_needed: "Transport",
    target_destination: "Destination Cible",
    details_reason: "Détails / Raison",
    send_to_planner: "Envoyer au Planificateur",
    add_rental: "Ajouter Machine de Location",
    machine_type: "Type de Machine",
    fleet_id: "ID Flotte / Label",
    confirm_import: "Enregistrer Machine",
    echo_tracker: "Suivi des Demandes",
    waiting: "En Attente",
    loading: "Chargement...",
    error: "Erreur",
    save: "Sauvegarder",
    cancel: "Annuler",
    delete: "Supprimer",
    confirm: "Confirmer",
    no_data: "Aucune donnée",
    refresh: "Rafraîchir",
    calendar: "Calendrier",
    feedback: "Retour",
    feedback_placeholder: "Partagez votre retour sur ce site...",
    submit_feedback: "Envoyer Retour",
    switch_driver: "Changer de Chauffeur",
    reschedule: "Replanifier",
  },
  de: {
    lobby_title: "Project Pigeon",
    lobby_subtitle: "Logistik Kommandozentrale",
    select_hub: "Hub Auswählen",
    select_role: "Wählen Sie Ihre Rolle",
    planner: "Planer",
    machinist: "Maschinist",
    driver: "Fahrer",
    viewer: "Zuschauer",
    language_gate: "Sprache Auswählen",
    enter_dashboard: "Dashboard Öffnen",
    back: "Zurück",
    exit: "Beenden",
    planner_dashboard: "Planer Dashboard",
    fleet_intelligence: "Flotten Intelligenz",
    all_regions: "Alle Regionen",
    search_placeholder: "Baustellen suchen...",
    sites: "Baustellen",
    machines: "Maschinen",
    drivers_title: "Fahrer",
    active: "Aktiv",
    offline: "Offline",
    efficiency: "Effizienz",
    stops: "Stopps",
    refuelings: "Betankungen",
    fleet_volume: "Flottenvolumen",
    active_drivers: "Aktiv",
    daily_progress: "Tagesfortschritt",
    analyze: "Analysieren",
    approve: "Genehmigen",
    data_synced: "Daten Synchronisiert",
    loading: "Laden...",
    driver_dashboard: "Fahrer Dashboard",
    start_day: "Tag Starten",
    stop_day: "Tag Beenden",
    day_status: "Tagesstatus",
    quick_actions: "Schnelle Aktionen",
    pause: "Pause",
    breakdown: "Panne",
    my_planning: "Meine Planung",
    no_planning: "Noch keine Planung",
    checklist: "Abfahrtskontrolle",
    confirm_delivery: "Lieferung Bestätigen",
    deliver: "Liefern",
    machinist_dashboard: "Maschinist Dashboard",
    select_site: "Baustelle Auswählen",
    machine_pool: "Maschinenpark",
    fuel_request: "Tankanfrage",
    action_center: "Aktionszentrum",
    send_to_planner: "An Planer Senden",
    messages: "Nachrichten",
    feedback: "Feedback",
    confirm: "Bestätigen",
  },
};

export function useTranslation(lang = "en") {
  const t = (key) => {
    const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;
    return dict[key] || TRANSLATIONS.en[key] || key;
  };
  return { t, lang };
}

export const SUPPORTED_LANGUAGES = [
  { code: "nl", label: "Nederlands", flag: "NL" },
  { code: "fr", label: "Français", flag: "FR" },
  { code: "en", label: "English", flag: "EN" },
  { code: "de", label: "Deutsch", flag: "DE" },
  { code: "pt", label: "Português", flag: "PT" },
  { code: "es", label: "Español", flag: "ES" },
  { code: "it", label: "Italiano", flag: "IT" },
  { code: "pl", label: "Polski", flag: "PL" },
  { code: "ro", label: "Română", flag: "RO" },
  { code: "tr", label: "Türkçe", flag: "TR" },
  { code: "ru", label: "Русский", flag: "RU" },
  { code: "zh", label: "中文", flag: "ZH" },
  { code: "ar", label: "العربية", flag: "AR" },
];

export default TRANSLATIONS;
